import DemoHoverBox from './DemoHoverBox';
import DemoContactBox from './DemoContactBox';
import { DotsNineIcon, LockSimpleIcon, ArrowUpRightIcon } from '@phosphor-icons/react';
import { RootState, useAppSelector } from '../../store';

export default function CTAModal() {
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const selectedLanguage = useAppSelector((state: RootState) => state.i18n.selectedLanguage);

    return (
        <div>
            <div className="h-full">
                <div className="flex justify-center">
                    <div className="mb-6 box bg-demo-BoxbackgroundColor rounded-2xl px-8">
                        <DemoContactBox
                            name="Thomas Dahlhaus"
                            position="Produktmanager"
                            phone="+49 2532 9509-152"
                            mobile="+49 175 6868 445"
                            email="thomas.dahlhaus@varios-ai.com"
                            emailLink="mailto:thomas.dahlhaus@varios-ai.com"
                            image="/img/dahlhaus_thomas.jpg"
                        />
                    </div>
                </div>
                <div className="p-8 py-4 rounded-2xl">
                    <div className="text-center mb-6">
                        <h4 className="p-0 m-0 mb-2">
                            {i18n.translate({
                                id: 'modal.contact.headline',
                                sourceName: 'Demo',
                            })}
                        </h4>
                        <p className="text-center text-fade-400 font-medium mt-2 max- m-auto">
                            {i18n.translate({
                                id: 'modal.contact.subline',
                                sourceName: 'Demo',
                            })}
                        </p>
                    </div>
                    <div className="grid lg:grid-cols-3 grid-cols-1 gap-8 mb-5">
                        <DemoHoverBox
                            title={i18n.translate({ id: 'modal.box1.headline', sourceName: 'Demo' })}
                            description={i18n.translate({ id: 'modal.box1.text', sourceName: 'Demo' })}
                            icon={<DotsNineIcon size={30} />}
                            link={
                                selectedLanguage === 'de'
                                    ? 'https://varios-ai.com/modular/'
                                    : 'https://varios-ai.com/en/modular/'
                            }
                        />
                        <DemoHoverBox
                            title={i18n.translate({ id: 'modal.box2.headline', sourceName: 'Demo' })}
                            description={i18n.translate({ id: 'modal.box2.text', sourceName: 'Demo' })}
                            icon={<LockSimpleIcon size={30} />}
                            link={
                                selectedLanguage === 'de'
                                    ? 'https://varios-ai.com/sicher/'
                                    : 'https://varios-ai.com/en/secure/'
                            }
                        />
                        <DemoHoverBox
                            title={i18n.translate({ id: 'modal.box3.headline', sourceName: 'Demo' })}
                            description={i18n.translate({ id: 'modal.box3.text', sourceName: 'Demo' })}
                            icon={<ArrowUpRightIcon size={30} />}
                            link={
                                selectedLanguage === 'de'
                                    ? 'https://varios-ai.com/transparent/'
                                    : 'https://varios-ai.com/en/transparent/'
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
